import { ConfirmationDialog, ModalInjectedProps } from '@sketch/components'
import React from 'react'

import { useToast } from '@sketch/toasts'
import { useUpdateWorkspaceProfileMutation } from '@sketch/gql-types'

interface PublishProfileModalProps extends ModalInjectedProps {
  identifier: string
}

export const PublishProfileModal: React.FCC<
  PublishProfileModalProps
> = props => {
  const { hideModal, isModalOpen, identifier } = props
  const { showToast } = useToast()

  const [publishProfile, { loading }] = useUpdateWorkspaceProfileMutation({
    onCompleted: () => {
      showToast('Public profile successfully published')
      hideModal()
    },
    onError: error => showToast(error.message, 'negative'),
    variables: {
      input: {
        identifier,
        isPublic: true,
      },
    },
  })

  return (
    <ConfirmationDialog
      title="Publish Documents?"
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Publish',
        variant: 'primary',
        loading,
        disabled: loading,
      }}
      onConfirm={publishProfile}
    >
      <p>
        These documents will be available for everyone to see on your public
        profile.
      </p>
      <p>
        The most recent saved or starred document versions will be visible and
        updates will appear automatically.
      </p>
    </ConfirmationDialog>
  )
}
